<template>
  <transition name="app-dialog" @after-enter="afterEnter" @after-leave="afterLeave">
    <div v-show="visible" class="app-dialog__wrapper" @click.self="handleWrapperClick">
      <div v-if="rendered" ref="dialog" aria-modal="true" aria-label="dialog" class="app-dialog__body">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
import Popup from '@/mixins/popup'
export default {
  name: 'AppDialog',
  mixins: [Popup],
  props: {
    // 是否显示遮罩层
    modal: {
      type: Boolean,
      default: true,
    },
    // 遮罩是否挂在body上
    modalAppendToBody: {
      type: Boolean,
      default: true,
    },
    // 弹窗主体是否挂在body上
    appendToBody: {
      type: Boolean,
      default: true,
    },
    // 是否点击遮罩层关闭弹窗
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    // 关闭前，可以控制弹窗是否关闭
    beforeClose: Function,
    destroyOnClose: Boolean,
  },
  data() {
    return {
      closed: false,
      key: 0,
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.closed = false
        this.$emit('open')
        if (this.appendToBody) {
          document.body.appendChild(this.$el)
        }
      } else {
        if (!this.closed) this.$emit('close')
        if (this.destroyOnClose) {
          this.$nextTick(() => {
            this.key++
          })
        }
      }
    },
  },
  methods: {
    handleWrapperClick() {
      if (!this.closeOnClickModal) return
      this.handleClose()
    },
    handleClose() {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide)
      } else {
        this.hide()
      }
    },
    hide(cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false)
        this.$emit('close')
        this.closed = true
      }
    },
    afterEnter() {
      this.$emit('opened')
    },
    afterLeave() {
      this.$emit('closed')
    },
  },
  mounted() {
    if (this.visible) {
      this.rendered = true
      this.open()
      if (this.appendToBody) {
        document.body.appendChild(this.$el)
      }
    }
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
}
</script>

<style lang="scss" scoped>
.app-dialog__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}
.app-dialog__body {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  word-break: break-all;
  -webkit-overflow-scrolling: touch;
}
.app-dialog-enter-active {
  animation: app-dialog-in 0.3s;
}

.app-dialog-leave-active {
  animation: app-dialog-out 0.3s;
}
@keyframes app-dialog-in {
  0% {
    transform: scale(1.185);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes app-dialog-out {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  to {
    transform: scale(0.85);
    opacity: 0;
  }
}
</style>

<style lang="scss">
.v-modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background: #000;
}
.v-modal-enter {
  animation: v-modal-in 0.2s ease;
}

.v-modal-leave {
  animation: v-modal-out 0.2s ease forwards;
}

@keyframes v-modal-in {
  0% {
    opacity: 0;
  }
}

@keyframes v-modal-out {
  to {
    opacity: 0;
  }
}
.app-popup-parent--hidden {
  overflow: hidden;
}
</style>
